'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { attachSubComponents, DefaultsContext, dontForwardProps, InternalProvider } from '../../util';
import { getSize } from './utils';
import { SSR } from './SSR/SSR';
import '@soluto-private/aui-external-svg-loader';
const SvgSpan = styled.span.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-c22xzd-0"
})(["display:inline-block;position:relative;vertical-align:middle;width:", ";height:", ";& > svg{display:block;width:100%;height:100%;}"], ({
  size
}) => getSize(size), ({
  size
}) => getSize(size));
const formatPath = (path, useCustomRoot) => {
  const CDN_ROOT = useCustomRoot ? 'https://assets.asurion-ui.my.asurion53.com/icons/' : `https://assets.asurion-ui.my.asurion53.com/icons/nova/`;
  if (!path.endsWith('.svg')) {
    path = path + '.svg';
  }
  return CDN_ROOT + encodeURI(path);
};
const BaseIcon = /*#__PURE__*/React.forwardRef(({
  title,
  ariaLabel,
  src,
  size,
  fill,
  svgProps,
  useCustomRoot = false,
  ...props
}, fRef) => {
  const {
    iconSize,
    iconFill
  } = useContext(DefaultsContext);
  size ||= iconSize ?? 'normal';
  fill ||= iconFill ?? 'black';
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(SvgSpan, _extends({
    size: size,
    ref: fRef
  }, props, {
    "data-aui": "icon"
  }), typeof src === 'string' ? /*#__PURE__*/React.createElement("svg", _extends({
    key: src,
    "data-src": formatPath(src, useCustomRoot),
    fill: fill,
    "aria-label": ariaLabel || title
  }, svgProps)) : src));
});
export const Compat = ({
  src,
  fill,
  svgProps,
  ...props
}) => {
  if (typeof src === 'string') {
    return /*#__PURE__*/React.createElement(SSR, _extends({
      src: src,
      color: fill
    }, svgProps, props));
  } else {
    return /*#__PURE__*/React.createElement(BaseIcon, _extends({
      src: src,
      fill: fill,
      svgProps: svgProps
    }, props));
  }
};
export const Icon = attachSubComponents('Icon', BaseIcon, {
  SSR,
  Compat
});